/* ═══════════════════════════════════════════════════════════════
   BATCH 7: Navigation Abstraction Layer
   Wraps window.location and window.open for React Native compatibility
   ═══════════════════════════════════════════════════════════════ */

export const openURL = (url) => {
  if (typeof window !== 'undefined' && window.open) {
    window.open(url, '_blank');
  }
};

export const getCurrentPath = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.pathname;
  }
  return '/';
};

export const getCurrentOrigin = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return '';
};

export const getSearchParams = () => {
  if (typeof window !== 'undefined' && window.location) {
    return new URLSearchParams(window.location.search);
  }
  return new URLSearchParams();
};

export const getHash = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.hash;
  }
  return '';
};

export const navigateTo = (url) => {
  if (typeof window !== 'undefined' && window.location) {
    window.location.href = url;
  }
};
